// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/transportation_place_types.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/transportation_place_types.proto.
 */
export const file_proto_model_core_place_types_transportation_place_types = /*@__PURE__*/
  fileDesc("Cj1wcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL3RyYW5zcG9ydGF0aW9uX3BsYWNlX3R5cGVzLnByb3RvEgZjYXJtZW4q3AUKF1RyYW5zcG9ydGF0aW9uUGxhY2VUeXBlEikKJVRSQU5TUE9SVEFUSU9OX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIlCiFUUkFOU1BPUlRBVElPTl9QTEFDRV9UWVBFX0FJUlBPUlQQARInCiNUUkFOU1BPUlRBVElPTl9QTEFDRV9UWVBFX0FJUlNUUklQRRACEikKJVRSQU5TUE9SVEFUSU9OX1BMQUNFX1RZUEVfQlVTX1NUQVRJT04QAxImCiJUUkFOU1BPUlRBVElPTl9QTEFDRV9UWVBFX0JVU19TVE9QEAQSLAooVFJBTlNQT1JUQVRJT05fUExBQ0VfVFlQRV9GRVJSWV9URVJNSU5BTBAFEiYKIlRSQU5TUE9SVEFUSU9OX1BMQUNFX1RZUEVfSEVMSVBPUlQQBhIzCi9UUkFOU1BPUlRBVElPTl9QTEFDRV9UWVBFX0lOVEVSTkFUSU9OQUxfQUlSUE9SVBAHEjAKLFRSQU5TUE9SVEFUSU9OX1BMQUNFX1RZUEVfTElHSFRfUkFJTF9TVEFUSU9OEAgSKwonVFJBTlNQT1JUQVRJT05fUExBQ0VfVFlQRV9QQVJLX0FORF9SSURFEAkSLAooVFJBTlNQT1JUQVRJT05fUExBQ0VfVFlQRV9TVUJXQVlfU1RBVElPThAKEigKJFRSQU5TUE9SVEFUSU9OX1BMQUNFX1RZUEVfVEFYSV9TVEFORBALEisKJ1RSQU5TUE9SVEFUSU9OX1BMQUNFX1RZUEVfVFJBSU5fU1RBVElPThAMEisKJ1RSQU5TUE9SVEFUSU9OX1BMQUNFX1RZUEVfVFJBTlNJVF9ERVBPVBANEi0KKVRSQU5TUE9SVEFUSU9OX1BMQUNFX1RZUEVfVFJBTlNJVF9TVEFUSU9OEA4SKAokVFJBTlNQT1JUQVRJT05fUExBQ0VfVFlQRV9UUlVDS19TVE9QEA9CQkIYVHJhbnNwb3J0YXRpb25QbGFjZVR5cGVzWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z");

/**
 * Describes the enum carmen.TransportationPlaceType.
 */
export const TransportationPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_transportation_place_types, 0);

/**
 * Transportation-related place types
 *
 * @generated from enum carmen.TransportationPlaceType
 */
export const TransportationPlaceType = /*@__PURE__*/
  tsEnum(TransportationPlaceTypeSchema);

